import { Coast } from "@/@types/shared/coast";
import { useCurrencyStore } from "@/store/modules/_shared/currency";

export function getCoast(coast: Array<Coast>): Coast | null {
  if (!coast || coast.length === 0) {
    console.error("Coast array cannot be empty");
    return null;
  }

  try {
    const currencyStore = useCurrencyStore();
    // Если есть стоимость в текущей валюте, возвращаем её
    if (currencyStore.currentCurrency) {
      const currentCoast = coast.find(
        (item) => item.currency === currencyStore.currentCurrency
      );
      if (currentCoast) {
        return currentCoast;
      }
    }

    // Если есть стоимость в валюте по умолчанию, возвращаем её
    if (currencyStore.defaultCurrency) {
      const defaultCoast = coast.find(
        (item) => item.currency === currencyStore.defaultCurrency
      );
      if (defaultCoast) {
        return defaultCoast;
      }
    }
    // Если нет подходящей валюты, возвращаем первую стоимость
  } catch (error) {
    console.warn("Currency store not available, using first coast item");
  }
  return coast[0];
}
